<h4 class="m-t-20 m-b-10">
    <input type="checkbox" class="m-r-10" name="customerDetailCheck"  (change)="validateAttachments($event.target.checked)" />
    {{ "Replacement Attachments" | translate }}
</h4>

<div *ngIf="imageUrls && imageUrls.length > 0; else noImages">
    <img *ngFor="let imageUrl of imageUrls" [src]="imageUrl" 
          (click)="openBlobInNewTab(imageUrl)" alt="Attachment Image"
          style="width: 250px; height: auto; margin-right: 10px;" />
</div>

<ng-template #noImages>
    <p style="font-weight: bold;">No images available.</p>
</ng-template>